import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetUser from "../../Services/Getuser";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "../../components/Modal";
import UpdateAccStatus from "../../forms/driver/UpdateAccStatus";
import AddEditDriver from "../../forms/driver/AddEditDriver";

const UnApprovedDrivers = () => {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null); // State to track modal type
  const [editingDriver, setEditingDriver] = useState(null); // State to hold editing driver details

  useEffect(() => {
    const fetchDrivers = async () => {
      setLoading(true);
      try {
        const data = await GetUser.fetchDriverList();

        setDrivers(Array.isArray(data.drivers) ? data.drivers : []);
        // console.log("DOcs: ", data);
      } catch (error) {
        console.error("Error fetching drivers:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDrivers();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this driver?")) return;
    try {
      await GetUser.deleteDriver(id);
      setDrivers((prev) => prev.filter((d) => d.id !== id));
    } catch (error) {
      console.error("Error deleting driver:", error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleEdit = (driver) => {
    setEditingDriver(driver);
    setModalType("edit"); // Set modal type to edit
    setShowModal(true);
  };

  const handleUpdateStatus = (driver) => {
    setEditingDriver(driver); // Set the driver to be updated
    setModalType("updateStatus"); // Set modal type to update status
    setShowModal(true);
  };

  return (
    <div className="content-wrapper">
      <ToastContainer />
      <div className="content-header">
        <h2 className="text-2xl font-bold">Driver Management</h2>
      </div>
      <div className="card">
        <div className="card-header flex items-center justify-between">
          {/* <button
            type="button"
            onClick={() => {
              setEditingDriver(null); // Clear editing driver for adding a new driver
              setModalType("add"); // Set modal type to add
              setShowModal(true);
            }}
            className="btn btn-primary btn-sm flex items-center"
          >
            <i className="fa fa-user mr-1"></i> Add Driver
          </button> */}
        </div>
        {showModal && (
          <Modal showModal={showModal} setShowModal={setShowModal}>
            {modalType === "add" || modalType === "edit" ? (
              <AddEditDriver
                editingDriver={editingDriver} // Pass the driver object to the modal
                setEditingDriver={setEditingDriver}
                setDrivers={setDrivers}
                setShowModal={setShowModal}
              />
            ) : modalType === "updateStatus" ? (
              <UpdateAccStatus
                editingDriver={editingDriver} // Pass the driver object to the modal
                setEditingDriver={setEditingDriver}
                setDrivers={setDrivers}
                setShowModal={setShowModal}
              />
            ) : null}
          </Modal>
        )}

        <div className="card-body flex flex-col gap-4">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex gap-4">
              <button type="button" className="btn btn-outline-secondary">
                CSV
              </button>
              <button type="button" className="btn btn-outline-secondary ml-2">
                Excel
              </button>
              <button type="button" className="btn btn-outline-secondary ml-2">
                PDF
              </button>
            </div>

            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              style={{ width: "300px" }}
            />
          </div>
          <div className="mt-4">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Country</th>
                  <th>Email</th>
                  <th>Total Rides</th>
                  <th>Account Status</th>
                  {/* <th>Activities</th> */}
                  {/* <th>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={8}>Loading drivers...</td>
                  </tr>
                ) : drivers.length ? (
                  drivers.map((driver) => (
                    <tr key={driver.id}>
                      <td>{driver.id}</td>
                      <td>{driver.name}</td>
                      <td>{driver.country}</td>
                      <td>{driver.email}</td>
                      <td>{driver.totalRides ?? 0}</td>
                      <td className="d-flex justify-content-center">
                        <button
                          className="btn btn-sm btn-warning align-center"
                          onClick={() => handleUpdateStatus(driver)} // Open update status modal
                        >
                          {driver.accountStatus}
                        </button>
                      </td>

                      {/* <td>
                        <button
                          className="btn btn-sm btn-primary mr-1"
                          onClick={() => handleEdit(driver)} // Open edit modal
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(driver.id)} // Delete driver
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8}>No drivers found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="card-footer clearfix">
            <ul className="pagination pagination-sm m-0 float-right">
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage > 1) handlePageChange(currentPage - 1);
                  }}
                >
                  &laquo;
                </a>
              </li>
              {[...Array(totalPages).keys()].map((page) => (
                <li
                  className={`page-item ${
                    currentPage === page + 1 ? "active" : ""
                  }`}
                  key={page + 1}
                >
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(page + 1);
                    }}
                  >
                    {page + 1}
                  </a>
                </li>
              ))}
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage < totalPages)
                      handlePageChange(currentPage + 1);
                  }}
                >
                  &raquo;
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnApprovedDrivers;
